var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.125,
    height: 20.55,
    viewBox: "0 0 17.125 20.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#000000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document_2_",
    "data-name": "document (2)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(4.11 14.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_23",
    "data-name": "Path 23",
    d: "M137.028,344h-.685a.343.343,0,0,0,0,.685h.685a.343.343,0,0,0,0-.685Z",
    transform: "translate(-136 -344)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(6.165 14.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_24",
    "data-name": "Path 24",
    d: "M192.563,344h-8.22a.343.343,0,0,0,0,.685h8.22a.343.343,0,0,0,0-.685Z",
    transform: "translate(-184 -344)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(4.11 12.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_25",
    "data-name": "Path 25",
    d: "M137.028,296h-.685a.343.343,0,0,0,0,.685h.685a.343.343,0,0,0,0-.685Z",
    transform: "translate(-136 -296)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(6.165 12.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_26",
    "data-name": "Path 26",
    d: "M192.563,296h-8.22a.343.343,0,0,0,0,.685h8.22a.343.343,0,0,0,0-.685Z",
    transform: "translate(-184 -296)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(4.11 10.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_27",
    "data-name": "Path 27",
    d: "M137.028,248h-.685a.342.342,0,1,0,0,.685h.685a.342.342,0,1,0,0-.685Z",
    transform: "translate(-136 -248)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(6.165 10.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_28",
    "data-name": "Path 28",
    d: "M192.563,248h-8.22a.342.342,0,1,0,0,.685h8.22a.342.342,0,0,0,0-.685Z",
    transform: "translate(-184 -248)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(4.11 8.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_29",
    "data-name": "Path 29",
    d: "M137.028,200h-.685a.342.342,0,1,0,0,.685h.685a.342.342,0,1,0,0-.685Z",
    transform: "translate(-136 -200)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(6.165 8.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_30",
    "data-name": "Path 30",
    d: "M192.563,200h-8.22a.342.342,0,1,0,0,.685h8.22a.342.342,0,0,0,0-.685Z",
    transform: "translate(-184 -200)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(4.11 6.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_31",
    "data-name": "Path 31",
    d: "M137.028,152h-.685a.343.343,0,1,0,0,.685h.685a.343.343,0,0,0,0-.685Z",
    transform: "translate(-136 -152)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(6.165 6.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_32",
    "data-name": "Path 32",
    d: "M192.563,152h-8.22a.343.343,0,0,0,0,.685h8.22a.343.343,0,0,0,0-.685Z",
    transform: "translate(-184 -152)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_33",
    "data-name": "Path 33",
    d: "M57.121,5.116a.323.323,0,0,0-.017-.088c0-.011-.007-.022-.011-.032a.342.342,0,0,0-.068-.1L52.228.1a.342.342,0,0,0-.1-.069c-.011,0-.021-.008-.032-.011A.341.341,0,0,0,52.007,0C52,0,52,0,51.988,0H42.4a.343.343,0,0,0-.343.343V1.37H40.343A.343.343,0,0,0,40,1.713v18.5a.343.343,0,0,0,.343.343H54.728a.343.343,0,0,0,.343-.343V18.5h1.713a.343.343,0,0,0,.343-.343V5.138C57.125,5.13,57.121,5.123,57.121,5.116ZM52.33,1.169,55.956,4.8H52.33Zm2.055,18.7h-13.7V2.055h1.37v16.1a.343.343,0,0,0,.343.343H54.385ZM56.44,17.81H42.74V.685h8.905V5.138a.343.343,0,0,0,.343.343H56.44Z",
    transform: "translate(-40)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(4.11 3.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_34",
    "data-name": "Path 34",
    d: "M138.4,72h-2.055a.343.343,0,0,0-.343.342V74.4a.343.343,0,0,0,.343.343H138.4a.343.343,0,0,0,.343-.343V72.342A.343.343,0,0,0,138.4,72Zm-.342,2.055h-1.37v-1.37h1.37Z",
    transform: "translate(-136 -72)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ce0edde30c0d9b03923e5df99b955669.svg";
export { ForwardRef as ReactComponent };